
import { defineComponent } from 'vue';

import useCompany from '@/stores/company';

export default defineComponent({
  name: 'EmptyLayout',

  props: {
    title: {
      type: String,
      required: true,
    },
  },

  setup() {
    return {
      companyStore: useCompany(),
    };
  },
});
